import {
  Box,
  Grid,
  Link,
  List,
  ListItem,
  Typography,
  useTheme,
} from "@mui/material";

export const ReturnPolicy = () => {
  const theme = useTheme();
  return (
    <Box>
      <Grid spacing={{ xs: 2, md: 3 }} mt={10} container>
        <Grid
          mb={5}
          display="flex"
          gap={5}
          p={5}
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          size={12}
        >
          <Typography
            sx={{
              fontSize: { xs: 28, sm: 30, md: 40 },
              fontWeight: 800,
              textAlign: "center",
              background: `linear-gradient(50deg, ${theme.palette.secondary[900]} , ${theme.palette.secondary[300]} 70%)`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Return Policy
          </Typography>

          <Box display="flex" gap={3} flexDirection="column">
            <Typography
              maxWidth={900}
              variant="body1"
              fontSize={{ xs: 12, md: 14 }}
              lineHeight={1.6}
              sx={{ color: theme.palette.secondary[500], textWrap: "pretty" }}
            >
              We want you to be completely satisfied with your purchase. If
              you're not happy with your purchase, you may exchange or return it
              within 30 days from the purchase date, provided it meets the
              following conditions:
            </Typography>

            <List sx={{display: "flex", flexDirection: "column", gap: 2}}>
              <ListItem sx={{ padding: 0 }}>
                <Typography
                  variant="body2"
                  fontSize={{ xs: 12, md: 14 }}
                  sx={{ color: theme.palette.secondary[500] }}
                >
                  • The item must be unworn and in its original packaging with
                  all tags attached."
                </Typography>
              </ListItem>
              <ListItem sx={{ padding: 0 }}>
                <Typography
                  variant="body2"
                  fontSize={{ xs: 12, md: 14 }}
                  sx={{ color: theme.palette.secondary[500] }}
                >
                  • There should be absolutely no visible wear on the item.
                </Typography>
              </ListItem>
              <ListItem sx={{ padding: 0 }}>
                <Typography
                  variant="body2"
                  fontSize={{ xs: 12, md: 14 }}
                  sx={{ color: theme.palette.secondary[500] }}
                >
                  • All sale items are final and not eligible for return or
                  exchange.
                </Typography>
              </ListItem>
            </List>

            <Typography
              maxWidth={900}
             variant="body1"
              fontSize={{ xs: 12, md: 14 }}
              lineHeight={1.6}
              sx={{ color: theme.palette.secondary[500], textWrap: "pretty" }}
            >
              To initiate a return or exchange, please contact us via phone{" "}
              <Link
                sx={{
                  textDecoration: "none",
                  color: theme.palette.primary[400],
                }}
                href="tel:+13213410151"
              >
                (321)341-0151
              </Link>{" "}
              or email{" "}
              <Link
                sx={{
                  textDecoration: "none",
                  color: theme.palette.primary[400],
                }}
                href="mailto:shop@nikolayorlando.com"
              >
                shop@nikolayorlando.com
              </Link>{" "}
              with your order number. We'll process your request within 5
              business days.
            </Typography>

            <Typography
              maxWidth={900}
               variant="body1"
              fontSize={{ xs: 12, md: 14 }}
              lineHeight={1.6}
              sx={{ color: theme.palette.secondary[500], textWrap: "pretty" }}
            >
              Please note that return shipping costs are the responsibility of
              the customer unless the return is due to a mistake on our part or
              a defective item.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
